export const MAX_PAYMENT_PROOFS = 8;
export const MAX_PROOF_BYTES = 10 * 1024 * 1024;

export function extractUploadUrl(up) {
  return up?.url || up?.imageUrl || up?.data?.url || "";
}

export function collectProofUrls(record) {
  if (!record || typeof record !== "object") return [];
  const extra = record.paymentProofUrls ?? record.payment_proof_urls ?? [];
  let list = [];
  if (Array.isArray(extra)) list = extra;
  else if (typeof extra === "string" && extra.trim()) {
    try {
      const parsed = JSON.parse(extra);
      list = Array.isArray(parsed) ? parsed : [extra];
    } catch {
      list = extra.includes(",") ? extra.split(",") : [extra];
    }
  }
  const first = record.paymentProofUrl || record.payment_proof_url || "";
  const merged = [...list, first]
    .map((u) => String(u || "").trim())
    .filter(Boolean);
  const seen = new Set();
  const out = [];
  for (const url of merged) {
    const key = url.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(url);
  }
  return out;
}

export async function uploadPaymentProofFiles(files, uploadSingle) {
  const list = Array.isArray(files) ? files.filter(Boolean) : [];
  if (!list.length) throw new Error("At least one payment proof attachment is required.");
  const urls = [];
  for (const file of list) {
    const up = await uploadSingle(file);
    const url = extractUploadUrl(up);
    if (!url) throw new Error("Failed to upload one of the payment proofs.");
    urls.push(url);
  }
  return urls;
}
